import type { IContent } from '../../../../../customTypings/epiBaseModels';
import type { EpiDynamicYieldBlockType } from './epiDynamicYieldBlockType';

export const isDynamicYieldBlock = (content: IContent): content is EpiDynamicYieldBlockType =>
    content?.contentType?.includes('DynamicYieldBlockType') === true;
